import { render } from "./ProfileOnboardComponent.vue?vue&type=template&id=d1e62e28&scoped=true"
import script from "./ProfileOnboardComponent.vue?vue&type=script&lang=js"
export * from "./ProfileOnboardComponent.vue?vue&type=script&lang=js"

import "./ProfileOnboardComponent.vue?vue&type=style&index=0&id=d1e62e28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e62e28"]])

export default __exports__